import React from 'react';
import { Button } from '../../components/button/Button';
import { Link } from 'react-router-dom';

export const Voltar = (props) => {
    return (
        <Link to={`/${props.page}`}><Button label="Voltar" icon="pi pi-arrow-left" className="p-button-warning p-mr-2" /></Link>
    );
}
